import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { Tabs } from 'antd';
import EmailInput from './emailInput';
import PhoneInp from './phoneInp';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { BiShowAlt } from "react-icons/bi";
import { MdEmail, MdSms } from "react-icons/md";
import { AXIOS, api_key } from "../../../config";
import { toast } from "react-toastify";
import check from '../../../assets/images/signin/checkmark.svg'
import { RiErrorWarningLine } from 'react-icons/ri'
import './phone.css'
import {updatePath} from '../../../store/auth/auth'
import { useDispatch } from "react-redux";

const onChange = (key: any, formik: any) => {
    console.log(key);
    let value = key == 1 ? 'email' : 'phone'
    console.log(formik);
    formik.setValues({
        ...formik.values,
        registerType: value
    })

};

export default function AntTabs({ formik }) {
    const [steps, setSteps] = useState(0)
    const [confirmPassword, setShownConfirmPassword] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [userId, setUserId] = useState('')
    const items = [
        {
            key: '1',
            label: `Email`,
            children: <EmailInput formik={formik} />,
        },
        {
            key: '2',
            label: `Mobile`,
            children: <PhoneInp formik={formik} />,
        },
    ];

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const location = useLocation();
    console.log('console.log(location.pathname)', location.pathname == '/resetPassword')

    const getOtp = async () => {
        // setMiliseconds(miliseconds + 1)

        try {
            let id = await AXIOS.post(`/getUserId`, {
                api_key: api_key,
                email: formik.values.email,
            });
            setUserId(id.data.data[0].user_id)
            console.log('id.data.data[0].user_id', id.data)
            let otpSent = await AXIOS.post(`/sendMail`, {
                api_key: api_key,
                user_id: id.data.data[0].user_id,
                reason: "change_password",
            })
            toast.success("Pin code sent to Email", { icon: <MdEmail /> });
            setSteps(steps + 1)
        } catch (error: any) {
            toast.error(error.message)
        }
    }


    const verifyPin = async () => {
        try {
            let validatePin = await AXIOS.post(`/forgetPinCheck`, {
                api_key: api_key,
                user_id: userId,
                mailPin: formik.values.pin
            })
            console.log('validatePin', validatePin.data.status)

            if (validatePin.data.status == 'fail') {
                toast.error(validatePin.data.showableMessage)

            }
            else {
                setSteps(steps + 1)
            }

        } catch (error: any) {
            toast.error(error)

        }
    }
    const updatePassword = async () => {
        try {
            let updatePassword = await AXIOS.post(`/forgetPassword`, {
                api_key: api_key,
                user_id: userId,
                password: formik.values.password
            });
            if (updatePassword.data.status == 'success') {
                toast.success(updatePassword.data.showableMessage)
                setSteps(steps + 1)

            }
            else {

            }

        } catch (error: any) {
            toast.error(error.message)
        }
    }

    const handleNext = async () => {
        switch (steps) {
            case 0:
                getOtp()
                break;
            case 1:
                verifyPin()
                break;
            case 2:
                updatePassword()
                break;


        }

    }
    return (
        <div className="form-group col-12 col-md-9 w-100 ">
            {
                steps == 0 ?
                    <>
                        {location.pathname == '/resetPassword' && <div className="reset_head">
                            <h2>Reset Password</h2>
                        </div>
                        }
                        <Tabs defaultActiveKey="1" items={items} onChange={(key) => onChange(key, formik)} />
                    </>

                    : steps == 1 ? <>
                        <div className="verify mb-4">
                            <h2>Security Verification</h2>
                            <span className="verify_span">
                                For your account security, please complete the following
                                verification operations
                            </span>
                        </div>
                        <label className='mb-2 sign_label'>Pin</label>
                        <input
                            type="number"
                            className="form-control"

                            name="pin"
                            placeholder="Enter Pin"

                            value={formik.values.pin}
                            onChange={formik.handleChange}
                        />
                        {formik.errors.pin && (
                            <div id="registerType" className="text-danger">
                                {formik.errors.pin}
                            </div>
                        )}
                        <p>Code will be sent to {formik.values.email}</p>

                    </> : steps == 2 ? <>
                        <h2>Reset Password</h2>
                        <Form.Group
                            className="mb-3 ver_grp"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label className="verify_lbl">New Password</Form.Label>
                            <Form.Control
                                type={`${showPassword == true ? 'text' : 'password'}`}

                                placeholder="0000"
                                autoFocus
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                            />


                            <div className="ver_grp_sp" onClick={() => { setShowPassword(!showPassword) }}>
                                <span><BiShowAlt className="fs-4" /></span>
                            </div>
                            {formik.errors.password && (
                                <div className="text-danger">
                                    {formik.errors.password}
                                </div>
                            )}
                        </Form.Group>
                        <Form.Group
                            className="mb-3 ver_grp"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label className="verify_lbl">Confirm Password</Form.Label>
                            <Form.Control

                                type={`${confirmPassword == true ? 'text' : 'password'}`}
                                placeholder="0000"
                                autoFocus
                                name="confirmPassword"
                                value={formik.values.confirmPassword}
                                onChange={formik.handleChange}
                            />


                            <div className="ver_grp_sp" onClick={() => { setShownConfirmPassword(!confirmPassword) }}>
                                <span><BiShowAlt className="fs-4" /></span>
                            </div>
                            {formik.errors.confirmPassword && (
                                <div className="text-danger">
                                    {formik.errors.confirmPassword}
                                </div>
                            )}
                        </Form.Group>

                    </> : <>
                        <div className=' mt-5'>
                            <div className="row">
                                <div className="col text-center">
                                    <div className='mb-3'>
                                        <img src={check} alt="" />
                                    </div>
                                    <div>
                                        <h2>Password Reset Complete </h2>
                                        <p className="text-muted">Please log in with new password</p>
                                    </div>
                                    <div>
                                        <button className='btn btn-warning w-75 py-2' onClick={() => {
                                            navigate("/login"); setSteps(0),dispatch(updatePath('login'))

                                        }}>Return</button>
                                    </div>
                                    <div className="mt-3 p-2   w-75 mx-auto" style={{ backgroundColor: 'rgba(255, 199, 43, 0.1)' }}>
                                        <RiErrorWarningLine className="me-2" />
                                        <small className="" style={{ fontSize: "0.750em" }}><b> For security reasons, after resetting password, digital currency withdrawals will be prohibited for 24 hours.</b></small>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }

            {
                location.pathname == '/resetPassword' && steps < 3 && <div className="nxt_btn mt-3">
                    <Button className="res_btn fw-bold p-2" 
                    disabled={
                       ( steps==0 && (formik.errors.email || formik.values.email=='')) 
                       ||  
                       ( steps==1 &&( formik.errors.pin || formik.values.pin==null))
                       ||  ( steps==2 &&( (formik.errors.password || formik.values.password=='') || (formik.errors.confirmPassword || formik.values.confirmPassword=='')))
                    }
                    onClick={handleNext}>Next</Button>
                </div>
            }

        </div>
    )
}  
